export const cities = '/cities';
